import { render, staticRenderFns } from "./veStuCheckItemTea.vue?vue&type=template&id=10769e06&scoped=true"
import script from "./veStuCheckItemTea.vue?vue&type=script&lang=js"
export * from "./veStuCheckItemTea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10769e06",
  null
  
)

export default component.exports